'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./svg-icon-501cae97.js');
var close = require('./close-40bc5458.js');
var button = require('./button-d7f037ee.js');
var emptyState = require('./empty-state-4520e4db.js');
var useTableContext_hook = require('./useTableContext.hook-ec1eae40.js');

var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  padding: 136px 0 184px;\n  max-width: 326px;\n  margin: auto;\n\n  p {\n    margin: 0;\n\n    &:first-of-type {\n      margin: 16px 0 4px;\n    }\n  }\n\n  button {\n    margin-top: 16px;\n    padding: 4px 28px;\n  }\n"], ["\n  padding: 136px 0 184px;\n  max-width: 326px;\n  margin: auto;\n\n  p {\n    margin: 0;\n\n    &:first-of-type {\n      margin: 16px 0 4px;\n    }\n  }\n\n  button {\n    margin-top: 16px;\n    padding: 4px 28px;\n  }\n"])));
var HqOTableEmptyState = function (_a) {
    var emptyStateButtonMethod = _a.emptyStateButtonMethod, emptyStateButtonText = _a.emptyStateButtonText, emptyStateIconClass = _a.emptyStateIconClass, emptyStateCustomIcon = _a.emptyStateCustomIcon, emptyStateSubtitle = _a.emptyStateSubtitle, emptyStateTitle = _a.emptyStateTitle, isLoading = _a.isLoading;
    var tableContext = useTableContext_hook.useTableContext();
    var data = tableContext.data.data;
    if ((data === null || data === void 0 ? void 0 : data.length) > 0 || isLoading) {
        return null;
    }
    var description = typeof emptyStateSubtitle === 'string' ? [emptyStateSubtitle]
        : emptyStateSubtitle;
    return (React__default.createElement(Container, { "data-testid": "hqo-table-empty-state", "data-cy": "hqo-table-empty-state", className: "table-empty-state" },
        React__default.createElement(emptyState.EmptyState, { size: "lg", title: emptyStateTitle, description: description, Icon: !emptyStateIconClass ? close.Close : undefined, faIconClassName: emptyStateIconClass, customIcon: emptyStateCustomIcon, dataTestId: emptyStateIconClass ? 'custom' : 'default-icon' }, emptyStateButtonMethod && emptyStateButtonText && (React__default.createElement(button.Button, { text: emptyStateButtonText, onClick: emptyStateButtonMethod, size: "md", "data-testid": "empty-state-cta" })))));
};
var templateObject_1;

exports.HqOTableEmptyState = HqOTableEmptyState;
